module.exports = __webpack_public_path__ + "img/cost.8202f3b4.png";